"use client";

import { createPortal } from "react-dom";
import { ToastContainer as ReactToastContainer } from "react-toastify";
import { useIsMounted } from "../../hooks/useIsMounted";
import { classNames } from "../../utils/classNames";

const TOAST_SURFACE_CLASSES =
	"pointer-events-auto mb-4 flex w-full max-w-md gap-2 rounded-lg bg-neutral shadow-lg before:pointer-events-none";

type ToastContainerProps = {
	className?: string;
	stacked?: boolean;
};

export const ToastContainer = ({ className, stacked = true }: ToastContainerProps) => {
	const isMounted = useIsMounted();

	if (!isMounted) {
		return null;
	}

	return createPortal(
		<ReactToastContainer
			stacked={stacked}
			icon={false}
			closeButton={false}
			hideProgressBar={true}
			draggable={false}
			autoClose={6_000}
			closeOnClick={false}
			toastClassName={() => TOAST_SURFACE_CLASSES}
			// toastify sizes only a stacked container, and toastClassName replaces the toast's own width
			className={classNames("z-toast", stacked ? undefined : "!w-80", className)}
		/>,
		document.body,
	);
};
